if (!customElements.get('step-tabs')) {
  class StepTabs extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.step-tabs__nav');
      this.panels = Array.from(this.querySelectorAll('[data-step-panel]'));

      if (!this.nav || !this.panels.length) return;

      this.buildNavigation();
      this.prepareMedia();
      this.select(0, false);

      this.addEventListener('keydown', this.onKeydown.bind(this));

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest?.('[data-step-panel]');
          const index = this.panels.indexOf(panel);
          if (index >= 0) this.select(index, false);
        });
      }
    }

    buildNavigation() {
      this.nav.replaceChildren();
      this.buttons = this.panels.map((panel, index) => {
        const button = document.createElement('button');
        const desktopLabel = document.createElement('span');
        const mobileLabel = document.createElement('span');
        const panelId = panel.id || `StepPanel-${this.dataset.sectionId}-${index}`;
        const buttonId = `StepTab-${this.dataset.sectionId}-${index}`;
        const label = panel.dataset.stepLabel || `Step ${index + 1}`;
        const mobileLabelText = panel.dataset.stepLabelMobile || label;

        panel.id = panelId;
        panel.setAttribute('aria-labelledby', buttonId);
        button.id = buttonId;
        button.className = 'step-tabs__tab';
        button.type = 'button';
        button.role = 'tab';
        desktopLabel.className = 'step-tabs__tab-label step-tabs__tab-label--desktop';
        desktopLabel.textContent = label;
        mobileLabel.className = 'step-tabs__tab-label step-tabs__tab-label--mobile';
        mobileLabel.textContent = mobileLabelText;
        button.append(desktopLabel, mobileLabel);
        button.setAttribute('aria-controls', panelId);
        button.setAttribute('aria-selected', 'false');
        button.tabIndex = -1;
        button.addEventListener('click', () => this.select(index));
        this.nav.append(button);
        return button;
      });
    }

    prepareMedia() {
      this.panels.forEach((panel) => {
        const content = panel.querySelector('.step-tabs__content');
        const image = Array.from(content?.children || []).find((child) =>
          child.matches('.relative') && child.querySelector('.image-block__wrapper')
        );

        if (content && image) {
          content.classList.add('has-media');
          image.classList.add('step-tabs__media');
        }
      });
    }

    select(index, focus = true) {
      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.hidden = !active;
        this.buttons[panelIndex].setAttribute('aria-selected', String(active));
        this.buttons[panelIndex].tabIndex = active ? 0 : -1;
      });

      const activeButton = this.buttons[index];
      if (focus) activeButton?.focus();
    }

    onKeydown(event) {
      const currentIndex = this.buttons.indexOf(event.target);
      if (currentIndex < 0) return;

      let nextIndex;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.buttons.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.buttons.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.select(nextIndex);
    }
  }

  customElements.define('step-tabs', StepTabs);
}
